import { removeUndefined } from '@src/lib/func/removeUndefined';
import { QueryClient } from '@tanstack/react-query';
import {
  FindOrCreateDraftJob as DraftJob,
  findOrCreateRepostDraftKey
} from '../useFindOrCreateDraftForRepost';
import { UseFindRecentDraftProps } from '../useFindOrCreateDraftForRepost';
import { UpdateDraftParams } from './useUpdateDraft';

type QueryArgs = UseFindRecentDraftProps;

export const optimisticallyUpdateRepostDraft = (
  draft: UpdateDraftParams['draft'],
  queryArgs: QueryArgs,
  queryClient: QueryClient
) => {
  const updatedDraft = updateParamsToDraft(draft);

  const key = findOrCreateRepostDraftKey(queryArgs);
  queryClient.setQueryData(key, (existingDraft: DraftJob) =>
    mergeData(existingDraft, updatedDraft)
  );
};

const mergeData = (
  existingDraft: DraftJob,
  updatedDraft: Partial<DraftJob>
): DraftJob => {
  return {
    ...existingDraft,
    ...updatedDraft
  } as DraftJob;
};

export const updateParamsToDraft = (
  params: UpdateDraftParams['draft']
): Partial<DraftJob> => {
  return removeUndefined({
    title: params.title,
    businessId: params.businessId,
    immediateStart: params.immediateStart,
    description: params.description,
    rightToWork: params.rightToWork,
    shiftAvailability: params.shiftAvailability,
    salary: params.salary ? params.salary : undefined,
    jobType: params.type,
    jobRole: params.role,
    workExperience: params.workExperience
  });
};
